import React, { createContext, useContext, useState, useEffect } from 'react';
import { CURRENCY_CONFIGS } from '../utils/currencyConfigs';

const CurrencyContext = createContext();

export function CurrencyProvider({ children, organization }) {
  const [currency, setCurrency] = useState(() => {
    const orgCurrency = organization?.preferred_currency;
    const savedCurrency = localStorage.getItem('preferredCurrency');
    return orgCurrency || savedCurrency || 'USD';
  });

  useEffect(() => {
    localStorage.setItem('preferredCurrency', currency);

    if (organization?.id) {
      fetch('/api/organizations/currency', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          organizationId: organization.id,
          currency
        })
      }).catch(err => console.error('Failed to update organization currency:', err));
    }
  }, [currency, organization?.id]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return [
    CURRENCY_CONFIGS[context.currency],
    (newCurrency) => context.setCurrency(newCurrency)
  ];
}